"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _PreviewIframe = _interopRequireDefault(require("../PreviewIframe/PreviewIframe"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    width: "100%",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
}));

const SketchfabPreview = ({
  sourceId
}) => {
  const embedUrl = "https://sketchfab.com/models/" + sourceId + "/embed";
  return _react.default.createElement(_PreviewIframe.default, {
    url: embedUrl
  });
};

const YouTubePreview = ({
  sourceId
}) => {
  const embedUrl = "https://www.youtube.com/embed/" + sourceId; // content.playerUrl 

  return _react.default.createElement(_PreviewIframe.default, {
    url: embedUrl
  });
};

const VimeoPreview = ({
  sourceId
}) => {
  const embedUrl = "https://player.vimeo.com/video/" + sourceId;
  return _react.default.createElement(_PreviewIframe.default, {
    url: embedUrl
  });
};

const templates = {
  "vimeo": VimeoPreview,
  "youtube": YouTubePreview,
  "sketchfab": SketchfabPreview
};

const SourcePreview = (_ref) => {
  let className = _ref.className,
      source = _ref.source,
      sourceId = _ref.sourceId,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "source", "sourceId"]);

  const classes = useStyles();
  const PreviewTemplate = source && templates[source];

  if (!PreviewTemplate) {
    return _react.default.createElement("figure", {
      className: className || classes.root
    }, _react.default.createElement("p", null, "No template for ", source));
  }

  return _react.default.createElement("figure", {
    className: className || classes.root
  }, _react.default.createElement(PreviewTemplate, {
    sourceId: sourceId
  }));
};

var _default = SourcePreview;
exports.default = _default;
module.exports = exports.default;